<template>
  <el-container>
    <el-main style="padding: 0">
      <div class="top2">
        <div style="width: 400px">
          <!-- <el-autocomplete class="inline-input" style="width: 400px;" size="medium" suffix-icon="el-icon-search" v-model="name" :fetch-suggestions="querySearch"  placeholder="输入员工姓名" :trigger-on-focus="false"  @select="handleSelect" @input="inputNothing">
						<template slot-scope="{ item }">
							<div class="name">{{ item.realName }}</div>
						</template>
					</el-autocomplete> -->
          <el-input
            size="mini"
            placeholder="输入员工姓名或者电话"
            suffix-icon="el-icon-search"
            v-model="name"
            @input="inputNothing"
            @keyup.enter.native="search"
          ></el-input>
        </div>
        <div>
          <el-button
            type="primary"
            @click="addEmployee(form)"
            size="mini"
            class="item_font"
            >添加</el-button
          >
        </div>
      </div>
      <div style="width: 100%; margin-top: 20px" class="item_font">
        <el-table
          :data="tableData"
          border
          highlight-current-row
          :header-cell-style="headerStyle"
          :max-height="maxHeight()"
          :cell-style="cellStyle"
          stripe
        >
          <el-table-column property="loginName" label="账号" width="120">
          </el-table-column>
          <el-table-column property="realName" label="姓名" width="120">
          </el-table-column>
          <el-table-column property="tel" label="手机号" width="150">
          </el-table-column>
          <el-table-column property="roleName" label="角色" width="150">
          </el-table-column>
          <el-table-column property="isCanuse" label="状态" width="80">
            <!-- <template slot-scope='scope'>
							<template v-if="tableData[start]=='[]'&&tableData[start].status==1" class="item_font">可用</template>
							<template v-if="tableData[start]=='[]'&&tableData[start].status==0" class="item_font">不可用</template>
							<template v-if="scope.row.status == 0" class="item_font">不可用</template>
							<template v-else class="item_font">可用</template>
						</template> -->
          </el-table-column>
          <el-table-column property="depName" label="部门"> </el-table-column>

          <el-table-column label="登陆状态" width="150">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                "
              >
                <span v-if="scope.row.csStatus == -1" style="color: #999999"
                  >离线</span
                >
                <span v-else-if="scope.row.csStatus == 1" style="color: #07c160"
                  >在线</span
                >
                <span v-else-if="scope.row.csStatus == 0" style="color: #de4f4f"
                  >离开</span
                >
                <span v-if="scope.row.csStatus == 2" style="color: #f7a400"
                  >忙碌</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column property="endTime" label="最后登录时间" width="200">
          </el-table-column>
          <el-table-column property="createTime" label="加入时间" width="200">
          </el-table-column>
          <el-table-column
            property="operate"
            label="操作"
            width="150"
            fixed="right"
          >
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-around;
                "
              >
                <el-button
                  :disabled="scope.row.csStatus == -1"
                  @click="logout(scope.row.id, scope.row.realName)"
                  type="text"
                  size="small"
                  class="item_font"
                  >登出</el-button
                >
                <el-button
                  @click="edit(scope, tableData[scope.$index])"
                  type="text"
                  size="small"
                  class="item_font"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="delet(scope, tableData[scope.$index])"
                  class="item_font"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
    <el-footer>
      <div
        style="
          display: flex;
          flex-direction: row;
          width: 60%;
          margin-left: 20%;
          justify-content: space-around;
        "
      >
        <el-pagination
          background
          :pager-count="9"
          :page-size="10"
          layout="prev, pager, next, total"
          :total="total"
          @prev-click="pre"
          @next-click="next"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-footer>
    <div v-if="editEmployee == true">
      <el-dialog
        title="编辑员工"
        :visible.sync="editEmployee"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="30%"
        center
      >
        <div style="margin: 0 auto; width: 320px">
          <el-form :model="editForm" :rules="rules">
            <el-form-item label="姓名:" :label-width="formLabelWidth1" required>
              <el-input
                v-model="editForm.realName"
                style="width: 220px"
                @keyup.enter.native="nextInput(3)"
              ></el-input>
            </el-form-item>
            <el-form-item label="账号:" :label-width="formLabelWidth1" required>
              <el-input
                v-model="editForm.loginName"
                style="width: 220px"
                @keyup.enter.native="nextInput(2)"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="tel"
              label="绑定手机:"
              :label-width="formLabelWidth1"
              required
            >
              <el-input
                v-model.number="editForm.tel"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="wechatNumber"
              label="微信号:"
              :label-width="formLabelWidth1"
              required
            >
              <el-input
                v-model="editForm.wechatNumber"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item label="部门:" :label-width="formLabelWidth1" required>
              <el-cascader
                v-model="editForm.depId"
                :options="departmentLst"
                @change="handleChange"
                :props="{ checkStrictly: true }"
                clearable
              ></el-cascader>
              <!-- <el-select v-model="editForm.depName" placeholder="请选择部门" style="width: 220px;">
								<el-option label="销售部" value="销售部"></el-option>
								<el-option label="开发部" value="开发部"></el-option>
								<el-option label="市场部" value="市场部"></el-option>
								<el-option label="客服部" value="客服部"></el-option>
							</el-select> -->
            </el-form-item>
            <el-form-item label="状态:" :label-width="formLabelWidth1" required>
              <el-select
                v-model="editForm.isCanuse"
                placeholder="请选择状态"
                style="width: 220px"
              >
                <el-option label="可用" value="1"></el-option>
                <el-option label="不可用" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色:" :label-width="formLabelWidth1" required>
              <el-select
                v-model="editForm.roleName"
                placeholder="请选择角色"
                style="width: 220px"
              >
                <el-option
                  v-for="item in tableDataRole"
                  :label="item.roleName"
                  :value="item.roleName"
                  :key="item.roleId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editEmployee = false">取 消</el-button>
          <el-button type="primary" @click="confirmEdit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div v-if="add == true">
      <el-dialog
        title="添加员工"
        :visible.sync="add"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="30%"
        center
      >
        <div style="margin: 0 auto; width: 320px">
          <el-form :model="form" :rules="rules">
            <el-form-item label="姓名:" :label-width="formLabelWidth" required>
              <el-input
                v-model="form.realName"
                style="width: 220px"
                @keyup.enter.native="nextInput(2)"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="账号:"
              :label-width="formLabelWidth"
              @keyup.enter.native="nextInput(3)"
              required
            >
              <el-input
                v-model="form.loginName"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="tel"
              label="绑定手机:"
              :label-width="formLabelWidth"
              required
            >
              <el-input
                v-model.number="form.tel"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="wechatNumber"
              label="微信号:"
              :label-width="formLabelWidth"
              required
            >
              <el-input
                v-model="form.wechatNumber"
                style="width: 220px"
                maxlengt="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="部门:" :label-width="formLabelWidth" required>
              <el-cascader
                v-model="value"
                :options="departmentLst"
                @change="handleChange"
                :props="{ checkStrictly: true }"
                clearable
              ></el-cascader>
              <!-- <el-select v-model="form.depId" placeholder="请选择部门" style="width: 220px;">
								<el-option label="销售部" value=2></el-option>
								<el-option label="客服部" value=3></el-option>
							</el-select> -->
            </el-form-item>
            <el-form-item label="状态:" :label-width="formLabelWidth" required>
              <el-select v-model="form.status" style="width: 220px">
                <el-option label="可用" value="1"></el-option>
                <el-option label="不可用" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色:" :label-width="formLabelWidth" required>
              <el-select
                v-model="form.roleId"
                placeholder="请选择"
                style="width: 220px"
              >
                <el-option
                  v-for="item in tableDataRole"
                  :label="item.roleName"
                  :value="item.id"
                  :key="item.roleId"
                ></el-option>
                <!-- <el-option label="销售" value=1></el-option>
								<el-option label="客服" value=2></el-option> -->
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="add = false">取 消</el-button>
          <el-button type="primary" @click="condirmAdd">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </el-container>
</template>

<script>
import { maxHeight } from "../../utils/tableHeight";
import { MessageBox } from "element-ui";
export default {
  name: "EmployeeList",
  props: ["tableData", "tableDataRole", "departmentLst", "total"],
  data() {
    var validatePhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      name: "",
      add: false,
      editEmployee: false,
      formLabelWidth: "85px",
      formLabelWidth1: "85px",
      editForm: {
        loginName: "001",
        realName: "001",
        tel: "AAA",
        roleName: "销售",
        status: 1,
        depName: "销售",
        roleId: 1,
        depId: 2,
        wechatNumber: "",
        isCanuse: "",
      },
      form: {
        loginName: "",
        realName: "",
        tel: "",
        roleId: "",
        status: "",
        depId: "",
        endTime: "",
        createTime: "",
        operate: "",
        id: "",
        wechatNumber: "",
      },
      start: 0,
      roleId: "",
      depid: "",
      value: [],
      options: [
        {
          value: "zhinan",
          label: "指南",
          children: [
            {
              value: "shejiyuanze",
              label: "设计原则",
              children: [{ value: "yizhi" }],
            },
          ],
        },
      ],
      rules: {
        tel: [
          { required: true, message: "联系电话不能为空" },
          { type: "number", message: "联系电话必须为数字" },
          { validator: validatePhone, trigger: "blur" },
        ],
        wechatNumber: [
          { required: true, message: "微信号不能为空" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      value1: "",
      depidLst: [],
      id: "",
      end: false,
      cur_page: 1,
    };
  },
  mounted() {
    // let self = this
    // 	document.onkeydown = function(e) {
    // 		let ev = document.all ? window.event : e
    // 		if (ev.keyCode === 13) {
    // 			self.handleSelect()
    // 		}
    // 	}
  },
  methods: {
    maxHeight,
    headerStyle({ rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 8) {
        return "text-align:center;color:#000000";
      } else {
        return "text-align:left;padding:15px;color:#000000";
      }
    },
    cellStyle({ columnIndex }) {
      if (columnIndex == 8) {
        return "text-align:center;";
      } else {
        return "text-align:left;padding:15px;";
      }
    },
    addEmployee() {
      this.form = {
        loginName: "",
        realName: "",
        tel: "",
        roleId: "",
        status: "",
        depId: "",
        endTime: "",
        createTime: "",
        operate: "",
        id: "",
        wechatNumber: "",
      };
      this.value = [];
      this.depid = "";
      this.add = !this.add;
    },
    delet(scope, form) {
      console.log("员工列表删除", this.cur_page, scope);
      this.editForm.id = form.id;
      this.$emit("delet", {
        tableName: "employee",
        ind: scope.$index,
        editForm: this.editForm,
        page: this.cur_page,
      });
    },

    getTree(id, data) {
      // 通过目标部门id和部门树来获取部门id的所有父部门id
      console.log("enter tree", id, data);
      for (var i = 0; i < data.length; i++) {
        if (this.end == true) {
          break;
        } else {
          // 通过索引i和数组长度来判断本层循环是否进入最后一个元素
          if (i === data.length - 1) {
            console.log("第一层判断");
            // console.log("本层最后一个元素",id,data[i].id)
            // 本层循环进入最后一个元素
            if (id !== data[i].id) {
              console.log("不是顶级部门");
              if (data[i].children != null) {
                // 部门有子部门，对子部门进行循环，先添加部门id到部门列表.
                // 若是对子部门循环完没有匹配到的且没有子部门，那么将刚刚添加的父部门id从数组删除
                this.depidLst.push(data[i].id);
                console.log("this.depidLst1", this.depidLst);
                this.getTree(id, data[i].children);
              } else {
                console.log("顶级部门");
                // 最后一个元素且没有子部门，还是未匹配到部门id，说明这层部门不符合，
                // 此时把之前数组记入的父部门id清除
                // console.log("最后一个元素没有被匹配到，且没有子部门")
                this.depidLst.pop();
              }
            } else {
              // 匹配到部门，添加部门id到部门列表，结束循环
              // console.log("bbbbbbbbbbb1",data[i].id)
              this.depidLst.push(data[i].id);
              // console.log("this.depidLst2",this.depidLst)
              this.end = true;
              break;
            }
          } else {
            console.log("第二层判断");
            // 本层循环非最后一个元素
            // console.log("本层其它元素",id,data[i].id)
            if (id !== data[i].id) {
              // 未匹配到部门
              if (data[i].children != null) {
                // 添加部门id到部门列表.部门有子部门，对子部门进行循环
                this.depidLst.push(data[i].id);
                // console.log("this.depidLst3",this.depidLst)
                this.getTree(id, data[i].children);
              } else {
                // 匹配失败，且部门没有子部门，循环下一个元素
                // console.log("其它元素没有被匹配到，且没有子部门")
              }
            } else if (id === data[i].id) {
              // 匹配到部门，添加部门id到部门列表，结束循环
              // console.log("bbbbbbbbbbb2",data[i].id)
              this.depidLst.push(data[i].id);
              // console.log("this.depidLst4",this.depidLst)
              this.end = true;
              break;
            }
          }
        }
      }
      console.log("部门id数组", this.depidLst);
    },

    logout(id, name) {
      console.log("logout id", id, name);
      const tipMsg = `是否确认登出${name}`;
      MessageBox.alert(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
      })
        .then(async () => {
          var api = "/manager/user/kickOut";
          const response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: {
              id: id,
            },
          });
          if (response.resultCode === "10000") {
            this.$message.success(`${name}已登出`);
            this.$emit("condirmAdd", {
              tableName: "employee",
              form: this.form,
              page: this.cur_page,
            });
          } else {
            this.$message.error(response.desc);
          }
        })
        .catch(() => {
          console.log(`取消登出`);
        });
    },

    edit(scope, form) {
      this.depidLst = [];
      this.end = false;
      console.log("员工列表编辑", form);
      this.getTree(form.depId, this.departmentLst);
      console.log("leave tree");
      this.editForm.loginName = form.loginName;
      this.editForm.realName = form.realName;
      this.editForm.tel = form.tel;
      this.editForm.wechatNumber = form.wechatNumber;
      this.editForm.roleName = form.roleName;
      this.$set(this.editForm, "depName", form.depName);
      // this.editForm.depName = form.depName;
      // this.editForm.status = form.status
      this.editForm.isCanuse = form.isCanuse;
      this.editForm.id = form.id;
      this.editForm.depId = this.depidLst;
      this.editForm.roleId = form.roleId;
      this.scopeIndex = scope.$index;
      this.editEmployee = true;
      // this.value=[]
      this.depid = form.depId;
      // console.log(111111111111,this.editForm)
      // this.$emit('searchFather', {
      // 	editForm: this.editForm,
      // })
      // this.value.push(form.depId)
      // this.value=["1", "19242d223579487188268b1ab9990a91", "8defe917136b4faa908e0a72e0e87596"]
      // console.log(this.value)
    },
    async condirmAdd() {
      this.form.depId = this.depid;
      this.form.id = "";
      console.log("添加员工", this.form);
      this.form.loginName = this.form.loginName.replace(/\s+/g, "");
      this.form.realName = this.form.realName.replace(/\s+/g, "");
      // this.form.tel = this.form.tel.replace(/\s+/g,"")
      this.form.wechatNumber = this.form.wechatNumber.replace(/\s+/g, "");
      if (this.form.depId == "") {
        this.open2("部门不能为空");
      } else if (this.form.loginName == "") {
        this.open2("登录名不能为空");
      } else if (this.form.realName == "") {
        this.open2("员工名称不能为空");
      } else if (this.form.tel == "") {
        this.open2("手机号不能为空");
      } else if (this.form.wechatNumber == "") {
        this.open2("微信不能为空");
      } else if (this.form.status == "") {
        this.open2("状态不能为空");
      } else if (this.form.roleId == "") {
        this.open2("角色不能为空");
      } else if (!/^1[3456789]\d{9}$/.test(this.form.tel)) {
        this.open2("请输入正确的手机号");
      } else if (
        !/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/.test(this.form.wechatNumber) &&
        !/^1[3456789]\d{9}$/.test(this.form.wechatNumber)
      ) {
        this.open2("请输入正确的微信号");
      } else {
        var api = "/manager/user/edit";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: {
            id: this.form.id,
            realName: this.form.realName,
            loginName: this.form.loginName,
            tel: this.form.tel,
            depId: this.form.depId,
            roleId: this.form.roleId,
            status: this.form.status == 1 ? 1 : 0,
            wechatNumber: this.form.wechatNumber,
          },
        });
        console.log("employeeEdit response = ", response);
        if (response.resultCode === "10000") {
          this.$message.success("保存成功，默认密码：123456");
          this.add = false;
          this.$emit("condirmAdd", {
            tableName: "employee",
            form: this.form,
            page: this.cur_page,
          });
        } else {
          this.$message.error(response.desc);
        }
      }
    },
    async confirmEdit() {
      console.log("this.editForm.isCanuse", this.editForm.isCanuse);
      this.editForm.loginName = this.editForm.loginName.replace(/\s+/g, "");
      this.editForm.realName = this.editForm.realName.replace(/\s+/g, "");
      this.editForm.wechatNumber = this.editForm.wechatNumber.replace(
        /\s+/g,
        ""
      );
      // this.editForm.tel = this.editForm.tel.replace(/\s+/g,"")
      if (this.editForm.depId == "") {
        this.open2("部门不能为空 ");
      } else if (this.editForm.loginName == "") {
        this.open2("登录名不能为空 ");
      } else if (this.editForm.realName == "") {
        this.open2("员工名称不能为空 ");
      } else if (this.editForm.tel == "") {
        this.open2("手机号不能为空 ");
      } else if (this.editForm.isCanuse == "") {
        this.open2("状态不能为空 ");
      } else if (this.editForm.roleId == "") {
        this.open2("角色不能为空 ");
      } else if (this.editForm.wechatNumber == "") {
        this.open2("微信号不能为空 ");
      } else if (!/^1[3456789]\d{9}$/.test(this.editForm.tel)) {
        this.open2("请输入正确的手机号");
      } else if (
        !/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/.test(this.editForm.wechatNumber) &&
        !/^1[3456789]\d{9}$/.test(this.editForm.tel)
      ) {
        this.open2("请输入正确的微信号");
      } else {
        this.editForm.depId = this.depid;
        if (this.editForm.isCanuse == 1 || this.editForm.isCanuse == "可用") {
          this.editForm.status = 1;
        } else {
          this.editForm.status = 0;
        }
        for (var i = 0; i < this.tableDataRole.length; i++) {
          if (this.editForm.roleName == this.tableDataRole[i].roleName) {
            this.editForm.roleId = this.tableDataRole[i].id;
          }
        }
        var api = "/manager/user/edit";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: {
            id: this.editForm.id,
            realName: this.editForm.realName,
            loginName: this.editForm.loginName,
            tel: this.editForm.tel,
            depId: this.editForm.depId,
            roleId: this.editForm.roleId,
            status: this.editForm.status,
            wechatNumber: this.editForm.wechatNumber,
          },
        });
        console.log("employeeEdit response = ", response);
        if (response.resultCode === "10000") {
          this.$message.success("保存成功");
          this.editEmployee = false;
        } else {
          // if(this.editForm.status==1){
          // 	this.editForm.status='可用'
          // }else{
          // 	this.editForm.status='不可用'
          // }
          this.$message.error(response.desc);
        }

        this.$emit("confirmEdit", {
          tableName: "employee",
          editForm: this.editForm,
          ind: this.scopeIndex,
          page: this.cur_page,
        });
      }
    },
    pre(info) {
      console.log("pre：", info);
      this.cur_page = info;
      this.$emit("clickPage", {
        tableName: "employee",
        page: info,
      });
    },
    next(info) {
      this.cur_page = info;
      console.log("next：", info);
      this.$emit("clickPage", {
        tableName: "employee",
        page: info,
      });
    },
    handleCurrentChange(val) {
      this.cur_page = val;
      console.log("当前页码：", val);
      console.log("当前页码：", val);
      this.$emit("clickPage", {
        tableName: "employee",
        page: val,
      });
    },
    querySearch(queryString, cb) {
      var tableData = this.tableData;
      var results = queryString
        ? tableData.filter(this.createFilter(queryString))
        : tableData;
      console.log("查询结果", queryString, results);
      if (results.length == 0) {
        results = [{ realName: "未搜索到数据" }];
      }
      this.$emit("roleRestart", {
        tableName: "employee",
      });
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        return (
          data.realName.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect() {
      // this.name = item.realName
      this.$emit("roleSearch", {
        tableName: "employee",
        value: this.value1,
      });
    },
    inputNothing(val) {
      console.log("输入值发生改变", val);
      this.value1 = val;
      if (val == "") {
        this.$emit("roleRestart", {
          tableName: "employee",
          val: val,
        });
      } else {
        this.$emit("roleSearch", {
          tableName: "employee",
          value: this.value1,
        });
      }
    },
    handleChange(value) {
      this.depid = value[value.length - 1];
      console.log(value, this.depid);
    },
    open2(info) {
      const text = info;
      this.$message.error(text);
    },
    search(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.handleSelect();
      }
    },
    nextInput(num) {
      var inputs = document.getElementsByTagName("input");
      console.log(inputs);
      inputs[num].focus();
    },
  },
};
</script>

<style>
.top2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
  width: 100%;
}
.opr {
  width: 40px;
  line-height: 20px;
  font-size: 12px;
  color: #35b9ff;
  cursor: pointer;
}
</style>
